import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { PRODUCTS } from '../helpers/build';

import ReleaseMetricsSelectorContainer
  from './../Containers/ReleaseMetricsSelectorContainer';
import ReleaseMetricsDurationChartContainer
  from './../Containers/ReleaseMetricsDurationChartContainer';
import ReleaseMetricsHitCountChartContainer
  from './../Containers/ReleaseMetricsHitCountChartContainer';
import ReleaseMetricsCaseSizeChartContainer
  from './../Containers/ReleaseMetricsCaseSizeChartContainer';
import ConditionalComponent from './ConditionalComponent';
import ReleaseMetricsPerformanceChartContainer from
  './../Containers/ReleaseMetricsPerformanceChartContainer';

const ReleaseMetricsComponent = ({ isAuthenticated, product }) => {
  return (
    <div>
      <ConditionalComponent condition={!isAuthenticated}>
        <center>
          <p style={{ color:'red' }}>
            Jira authentication is required to determine which scenarios can be displayed.
            Please log in to ensure this page's full functionality.
          </p>
        </center>
      </ConditionalComponent>
      <Row>
        <Col sm={10} md={10} mdOffset={1}>
          <Row>
            <ReleaseMetricsSelectorContainer />
          </Row>
        </Col>
      </Row>
      <Row>
        <ConditionalComponent
          condition={product !== PRODUCTS.EXAMINE}
          children={<div>
            <Col md={4}>
              <h2> Duration </h2>
              <ReleaseMetricsDurationChartContainer />
            </Col>
            <Col md={4}>
              <h2> Hit Count </h2>
              <ReleaseMetricsHitCountChartContainer />
            </Col>
            <Col md={4}>
              <h2> Case Size </h2>
              <ReleaseMetricsCaseSizeChartContainer />
            </Col>
          </div>}
          elseChildren={<div>
            <Col md={8} >
              <h2>Examine Performance</h2>
              <ReleaseMetricsPerformanceChartContainer />
            </Col>
          </div>}
        />
      </Row>
    </div>
  );
};

ReleaseMetricsComponent.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  product: PropTypes.string.isRequired
};

export default ReleaseMetricsComponent;


// WEBPACK FOOTER //
// src/Components/ReleaseMetricsComponent.jsx